import React, { useEffect } from "react";
import { initGA, logPageView } from "./utils/analytics";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Portal from "./pages/Portal";
import QRCodePage from "./pages/QRCodePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import DeleteAccount from "./pages/DeleteAccount"; // 🔹 nova importação

import CookieBanner from "./components/CookieBanner"; 
import "./styles/global.css"; 

const AnalyticsListener = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};

const App = () => {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <AnalyticsListener />
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/qrcode" element={<QRCodePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/excluir-conta" element={<DeleteAccount />} /> {/* ✅ nova rota */}

        </Routes>
        <CookieBanner />
      </div>
    </Router>
  );
};

export default App;
